<template>
  <div>
    <template v-for="(item, n) in value">
      <MenuItem
        v-if="!item.meta.externalLink && (!item.meta.casl || $can( ...item.meta.casl ))"
        :key="`ext${n}`"
        :data-qa="item.name || `menu-item-${n}`"
        :disabled="item.disabled"
        :icon="item.meta.icon || 'share'"
        :label="$t(item.meta.caption)"
        :small="false"
        :to="{name: item.name, path: item.path, params: { org: storedCurrentOrganization.organizationItId }}"/>
      <MenuItem
        v-else-if="!item.meta.casl || $can( ...item.meta.casl )"
        :key="`int${n}`"
        :data-qa="item.name || `menu-item-${n}`"
        :disabled="item.disabled"
        :href="item.href"
        :icon="item.meta.icon || 'share'"
        :label="$t(item.meta.caption)"
        :small="false"
        target="_blank"
        @click="$emit('closeMenu')"/>
    </template>
  </div>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'TenderMenu',
  computed: {
    ...mapGetters({
      storedCurrentOrganization: 'getCurrentOrganization',
    }),
  },
  components: {
    MenuItem
  },
  props: {
    value: {
      type: Array
    }
  },
}
</script>
